import { render, staticRenderFns } from "./GamePlay.vue?vue&type=template&id=6d954df8&scoped=true&"
import script from "./GamePlay.vue?vue&type=script&lang=js&"
export * from "./GamePlay.vue?vue&type=script&lang=js&"
import style0 from "./GamePlay.vue?vue&type=style&index=0&id=6d954df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d954df8",
  null
  
)

export default component.exports